import WorldwideAPI from '@/api/worldwide'

const state = {
    region_code: 'UA',

    //Even here, we must set some default value
    region: {
        phone_code: '380',
        language: 'uk',
        systems: [],
        online_payment: false,
        liqpay: false,
        novaPoshta: false
    }
};

const mutations = {
    setRegionCode(state, payload) {
        state.region_code = payload;
    },
    setRegion(state, payload) {
        state.region = payload;
    }
}

const actions = {
    init(context, payload) {
        context.commit('setRegionCode', payload);

        return new Promise((resolve, reject) => {
            WorldwideAPI.getRegion(payload).then(data => {
                context.commit('setRegion', data.region);

                resolve();
            }).catch(error => {
                console.error(error);
                resolve();
            });
        })
    }
}

const getters = {
    phoneMask(state) {
        if (state.region.dashboard_phone_mask) {
            return state.region.dashboard_phone_mask;
        }
        if (state.region.country_code == 'UA') return '+38-###-###-##-##';
        if (state.region.country_code == 'RU') return '+7-###-###-##-##';
        if (state.region.country_code == 'CZ') return '+420-###-###-###';
        if (state.region.country_code == 'UZ') return '+998-##-###-##-##';
        if (state.region.country_code == 'IN') return '+91-####-###-###';  
        if (state.region.country_code == 'ES') return '+34-###-###-##-##';
        if (state.region.country_code == 'AD') return '+376-###-###';
        return `+${state.region.phone_code}-###-###-##-##`
    },
    googleMapsCountry(state) {
        return state.region_code.toLowerCase();
    },
    checkSystem(state, getters, rootState) {
        return (system) => {
            if (system == 'delivery' && rootState.cafe._id == 126) {
                return true;
            }

            if (system == 'preorder' && rootState.cafe._id == 126) {
                return true;
            } 

            return state.region.systems.includes(system);
        }
    },
    checkPaymentGateway(state) {
        return (gateway) => {
            return !!state.region.payment_gateways.includes(gateway);
        }
    },
    isOnlinePaymentAvailable(state) {
        return !!state.region.payment_gateways && !!state.region.payment_gateways.length;
    },
    checkIntegration(state) {
        return (name) => {
            return !!state.region.integrations.includes(name);
        }
    },
    checkService(state) {
        return (name) => {
            return !!state.region.services.includes(name);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}